(() => {
  const proxyRoot = '/apps/rd-photo-upload/pwa';
  const isStandalone = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

  const base64UrlToUint8Array = value => {
    const padding = '='.repeat((4 - value.length % 4) % 4);
    const base64 = (value + padding).replace(/-/g, '+').replace(/_/g, '/');
    const raw = atob(base64);
    return Uint8Array.from([...raw].map(character => character.charCodeAt(0)));
  };

  async function registration() {
    if (!('serviceWorker' in navigator)) return null;
    return navigator.serviceWorker.register(`${proxyRoot}/sw.js`, {scope: `${proxyRoot}/`});
  }

  async function config() {
    const response = await fetch(`${proxyRoot}/config`, {credentials: 'same-origin'});
    if (!response.ok) throw new Error('Push configuration unavailable.');
    return response.json();
  }

  async function saveSubscription(subscription) {
    const response = await fetch(`${proxyRoot}/subscribe`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({subscription: subscription.toJSON()}),
    });
    if (!response.ok) throw new Error('Unable to save notification subscription.');
  }

  async function enableNotifications(button) {
    button.disabled = true;
    const original = button.textContent;
    button.textContent = 'Enabling…';
    try {
      const serviceWorker = await registration();
      if (!serviceWorker || !serviceWorker.pushManager) throw new Error('Push notifications are not supported on this device.');

      const permission = await Notification.requestPermission();
      if (permission !== 'granted') throw new Error('Notification permission was not granted.');

      const settings = await config();
      let subscription = await serviceWorker.pushManager.getSubscription();
      if (!subscription) {
        subscription = await serviceWorker.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: base64UrlToUint8Array(settings.vapidPublicKey),
        });
      }
      await saveSubscription(subscription);
      localStorage.setItem('rd-pwa-push-enabled', '1');
      button.textContent = 'Notifications enabled';
      setTimeout(() => button.remove(), 1600);
    } catch (error) {
      console.error('[R&D PWA]', error);
      button.disabled = false;
      button.textContent = original;
      alert(error.message || 'Unable to enable notifications.');
    }
  }

  function notificationButton() {
    if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) return;
    if (Notification.permission === 'denied' || localStorage.getItem('rd-pwa-push-enabled') === '1') return;

    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = 'Enable notifications';
    button.setAttribute('aria-label', 'Enable R&D 3D Printing notifications');
    Object.assign(button.style, {
      position: 'fixed',
      right: '16px',
      bottom: '16px',
      zIndex: '2147483000',
      border: '0',
      borderRadius: '999px',
      padding: '12px 16px',
      font: 'inherit',
      fontWeight: '600',
      cursor: 'pointer',
      boxShadow: '0 4px 18px rgba(0,0,0,.18)',
      background: 'rgb(var(--color-button, 18, 18, 18))',
      color: 'rgb(var(--color-button-text, 255, 255, 255))',
    });
    button.addEventListener('click', () => enableNotifications(button));
    document.body.appendChild(button);
  }

  window.addEventListener('load', async () => {
    try {
      const serviceWorker = await registration();
      if (serviceWorker) {
        const existing = await serviceWorker.pushManager?.getSubscription();
        if (existing) {
          await saveSubscription(existing);
          localStorage.setItem('rd-pwa-push-enabled', '1');
        }
      }
    } catch (error) {
      console.warn('[R&D PWA] Service worker registration failed:', error);
    }

    // iPhone/iPad Web Push is available to Home Screen web apps. Other
    // supported browsers can opt in directly from the storefront.
    if (isStandalone() || !/iP(hone|ad|od)/.test(navigator.userAgent)) notificationButton();
  });
})();
